import * as yup from 'yup';

import { FORM_FIELDS } from '@constants/form';

export const UPDATE_APR_DOCUMENT = FORM_FIELDS.EMPLOYEE.APR.UPDATE_APR_DOCUMENT;

export const aprValidation = yup.object().shape({
  [UPDATE_APR_DOCUMENT.YEAR]: yup
    .number()
    .transform((value, originalValue) => (originalValue === '' ? null : value))
    .nullable()
    .required('Year is required')
    .typeError('Year has to be a number')
    .integer('Year cannot have decimal values')
    .positive('Year cannot be negative')
    .max(9999, 'No longer than 4 character'),
  [UPDATE_APR_DOCUMENT.MARK]: yup
    .number()
    .transform((value, originalValue) => (originalValue === '' ? null : value))
    .nullable()
    .required('Mark is required')
    .typeError('Mark has to be a number'),
});

export type APRFormData = yup.InferType<typeof aprValidation>;
